// extracted by mini-css-extract-plugin
module.exports = {"change_domain_title":"SiteSettings_change_domain_title__3pDaC","change_domain_url":"SiteSettings_change_domain_url__2X7si"};